function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(12.000000, 0.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, React.createElement("rect", {
  x: 13,
  y: 12.5882353,
  width: 2.5,
  height: 7.41176471,
  rx: 1
}), React.createElement("rect", {
  x: 3,
  y: 16.5882353,
  width: 2.5,
  height: 3.41176471,
  rx: 1
}), React.createElement("rect", {
  x: 8,
  y: 9.23529412,
  width: 2.5,
  height: 10.7647059,
  rx: 1
}), React.createElement("rect", {
  x: 18,
  y: 4,
  width: 2.5,
  height: 16,
  rx: 1
}), React.createElement("path", {
  d: "M22.7915039,1.59814453 L22.7915039,20.5 C22.7915039,21.0522847 22.3437887,21.5 21.7915039,21.5 L1,21.5 C0.44771525,21.5 -6.76353751e-17,21.9477153 0,22.5 C2.02974496e-15,23.0522847 0.44771525,23.5 1,23.5 L23.7915039,23.5 L23.7915039,23.5 C24.3437887,23.5 24.7915039,23.0522847 24.7915039,22.5 L24.7915039,1.59814453 C24.7915039,1.04585978 24.3437887,0.598144531 23.7915039,0.598144531 C23.2392192,0.598144531 22.7915039,1.04585978 22.7915039,1.59814453 Z"
})));

const SvgReportingIcon = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: "51px",
  height: "25px",
  viewBox: "0 0 51 25",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgReportingIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/reporting-icon.bfb269d5.svg";
export { ForwardRef as ReactComponent };